import React from 'react';
import { translate, Interpolate } from 'react-i18next';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { sunburst } from 'react-syntax-highlighter/styles/hljs';

const examplerRequest = `curl https://mise.se/TestAPI/api/getCompany?id=5566720750 \\
  -H "Authorization: Basic TWlzZUFwaTpNaXNlQXBpIzIwMTgwNA=="`;

const BusinessIdSection = (props) => (
  <section className="method row" id="find-business-by-id">
  <div className="method__text col-lg-6">
    <h1 className="h2">{props.t('title')} <span className="badge badge-primary">GET</span></h1>
    <hr />
    <Interpolate i18nKey='description' useDangerouslySetInnerHTML={true} />
    <h5>{props.t('common:params')}</h5>
    <div className="table-responsive">
      <table className="table table-striped">
        <tbody>
          <tr>
            <th>
              id<br />
              <small>{props.t('common:required')}</small>
            </th>
            <td>{props.t('params.id')} </td>
          </tr>                 
        </tbody>
      </table>
    </div>
  </div>
  <div className="method__code col-lg-6">
    <small>{props.t('common:exampleRequest')}</small>
    <SyntaxHighlighter language='text' style={sunburst}>
      {
        `GET https://mise.se/TestAPI/api/getCompany?id={COMPANY_ID}`
      }          
    </SyntaxHighlighter>
    <small>{props.t('common:exampleRequest')}</small>
    <SyntaxHighlighter language='bash' style={sunburst}>
      { examplerRequest }          
    </SyntaxHighlighter>
  </div>
</section>  
);

export default translate(['BusinessIdSection', 'common'])(BusinessIdSection);



// WEBPACK FOOTER //
// ./src/components/sections/business/BusinessIdSection.jsx